import { MelioLogo } from '@/components/ds';
import { asset } from '@/lib/assets';

// api-landing.tsx — developer preview front door: pitch + link straight to the API reference.

function ApiLanding() {
  return (
    <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 32 }}>
      <div style={{ maxWidth: 600, textAlign: 'center' }}>
        <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8, marginBottom: 26 }}>
          <MelioLogo height={22} />
          <span style={{ width: 1, height: 16, background: 'var(--border-static)' }} />
          <img src={asset('api-badge.svg')} alt="API Beta" style={{ height: 14, display: 'block' }} />
        </div>

        <div className="eyebrow" style={{ color: 'var(--accent)', marginBottom: 16 }}>
          Developer preview
        </div>

        <h1 style={{ fontWeight: 700, fontSize: 'clamp(34px,5vw,52px)', letterSpacing: '-.03em', lineHeight: 1.05, margin: 0 }}>
          Melio Payments API
        </h1>

        <p style={{ color: 'var(--text-secondary)', fontSize: 18, lineHeight: 1.6, margin: '20px auto 34px', maxWidth: 500 }}>
          A REST API for moving money between businesses — collect funds, pay out on any rail, and track each payment. Start with the API
          reference below.
        </p>

        <a
          href="/docs"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 10,
            fontFamily: 'var(--font-primary)',
            fontWeight: 600,
            fontSize: 16,
            background: 'var(--accent)',
            color: '#fff',
            borderRadius: 'var(--radius-300)',
            padding: '15px 26px',
            textDecoration: 'none',
            boxShadow: '0 12px 30px -14px rgba(108,71,255,.7)',
          }}
        >
          Go to API reference
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M3 8h9M9 4l4 4-4 4" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </a>
      </div>
    </div>
  );
}

export { ApiLanding };
